import { createContext, useContext } from 'react';

export type KickSimMutationArgs = {
  enabled: boolean;
  euicc: string;
  profileId: 0 | 1;
};

type KickSimContextType = {
  isPrimaryProfileDisabled: (euicc: string) => boolean;
  isSecondaryProfileDisabled: (euicc: string) => boolean;
  kickSim: (args: KickSimMutationArgs) => void;
};

export const KickSimContext = createContext<KickSimContextType>(null!);

export const useKickSimContext = () => {
  const kickSimContext = useContext(KickSimContext);

  if (!kickSimContext) {
    throw new Error('useKickSimContext has to be used within <KickSimContext.Provider>');
  }

  return kickSimContext;
};
